import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'
import { callApi } from 'duck/operations'
import { all, put, takeEvery } from 'redux-saga/effects'
import { ActionType, getType } from 'typesafe-actions'
import { isBefore, subSeconds } from 'utils-next/dates'

import { deleteDeal, emailDeal, markDealAsNew, updateDealInfoBegin, updateDealInfoSuccess } from './actions'
import { apiDeleteDeal, apiMarkDealAsNew, apiSendEmail, apiUpdateDealInfo } from './api'
import { Deal } from './types'

export function* dealsSaga() {
  yield all([
    takeEvery(getType(deleteDeal.request), deleteDealEffect),
    takeEvery(getType(updateDealInfoBegin), updateDealInfo),
    takeEvery(getType(markDealAsNew.request), markDealAsNewSaga),
    takeEvery(getType(emailDeal.request), sendDealEmail),
  ])
}

export function wasLessThen5SecondsAgo(time: Date | undefined): boolean {
  if (!time) {
    return false
  }
  const now = new Date()
  const fiveSecondsAgo = subSeconds(now, 5)
  return isBefore(time, fiveSecondsAgo)
}

function* markDealAsNewSaga(action: ActionType<typeof markDealAsNew.request>) {
  const dealId = action.payload
  const deal: Deal = yield callApi(apiMarkDealAsNew, dealId)
  yield put(markDealAsNew.success(deal))
}

function* deleteDealEffect(action: ActionType<typeof deleteDeal.request>) {
  const dealId = action.payload
  yield callApi(apiDeleteDeal, dealId)
  yield put(deleteDeal.success(dealId))
}

function* updateDealInfo(action: ActionType<typeof updateDealInfoBegin>) {
  const { dealId, dealInfo } = action.payload
  const updatedDeal: Deal = yield callApi(apiUpdateDealInfo, dealId, dealInfo)
  yield put(updateDealInfoSuccess(updatedDeal))
}

export function* sendDealEmail(action: ActionType<typeof emailDeal.request>) {
  try {
    yield callApi(apiSendEmail, action.payload)
    yield put(
      showFlashNotice({
        message: 'Email successfully sent!',
        autoHide: true,
        variant: FlashNoticeVariant.info,
      })
    )
  } catch (error) {
    yield put(
      showFlashNotice({
        message: 'There was an error while trying to send the email',
        autoHide: true,
        variant: FlashNoticeVariant.error,
      })
    )
  }
}
